import { render } from "./Transformer.vue?vue&type=template&id=5356f5b8&scoped=true"
import script from "./Transformer.vue?vue&type=script&lang=js"
export * from "./Transformer.vue?vue&type=script&lang=js"

import "./Transformer.vue?vue&type=style&index=0&id=5356f5b8&lang=scss&scoped=true"

import exportComponent from "E:\\aaes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5356f5b8"]])

export default __exports__